import { TimeframeOptions } from "./TimeframeOptions";

export const resolveDefaultTimeframeOptions = (
  options?: Partial<TimeframeOptions>
): TimeframeOptions => {
  const allowedUnits = options?.allowedUnits ?? ["year", "month"];
  const unit = options?.unit ?? allowedUnits[allowedUnits.length - 1];
  const defaultOptions: TimeframeOptions = {
    disallowFuture: false,
    unit: unit,
    allowedUnits: allowedUnits,
  };
  return Object.assign(defaultOptions, options);
};
